import React, { useState, useCallback } from 'react';
import classNames from 'classnames';

import styles from './numeric-stepper.module.css';

interface NumericStepperProps {
  initialValue?: number;
  minValue?: number;
  maxValue?: number;
  step?: number;
  onChange?: (value: number) => void;
}

const NumericStepper: React.FC<NumericStepperProps> = ({
  initialValue = 0,
  minValue = Number.MIN_SAFE_INTEGER,
  maxValue = Number.MAX_SAFE_INTEGER,
  step = 1,
  onChange,
}) => {
  const [value, setValue] = useState(initialValue);

  const increment = useCallback(() => {
    const newVal = Math.min(value + step, maxValue);
    if (newVal !== value) {
      setValue(newVal);
      if (onChange) {
        onChange(newVal);
      }
    }
  }, [maxValue, onChange, step, value]);

  const decrement = useCallback(() => {
    const newValue = Math.max(value - step, minValue);
    if (newValue !== value) {
      setValue(newValue);
      if (onChange) {
        onChange(newValue);
      }
    }
  }, [minValue, onChange, step, value]);

  return (
    <div className={styles['numeric-stepper']}>
      <button
        className={classNames(styles['stepper-button'], styles['minus'], 'padding-0')}
        onClick={decrement}
        disabled={value <= minValue}
      >
        <span>-</span>
      </button>
      <div className={classNames(styles['stepper-value'], 'H5')}>{value}</div>
      <button
        className={classNames(styles['stepper-button'], styles['plus'], 'padding-0')}
        onClick={increment}
        disabled={value >= maxValue}
      >
        <span>+</span>
      </button>
    </div>
  );
};

export default NumericStepper;
